const initSidePopup = () => {
  const popups = document.querySelectorAll('.side-popup');
  if (!popups.length) return;

  const openPopup = (popup) => {
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closePopup = (popup) => {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  // Open popup from any anchor that matches an aside ID
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const targetId = link.getAttribute('href').substring(1);
    if (!targetId) return;

    const popup = document.getElementById(targetId);
    if (!popup || !popup.classList.contains('side-popup')) return;

    e.preventDefault();
    openPopup(popup);
  });

  // Attach close logic per popup
  popups.forEach((popup) => {
    const closeButton = popup.querySelector('.side-popup__close');
    const overlay = popup.querySelector('.side-popup__overlay');

    if (closeButton) {
      closeButton.addEventListener('click', () => closePopup(popup));
    }

    if (overlay) {
      overlay.addEventListener('click', () => closePopup(popup));
    }
  });

  // Close on ESC (only the open one)
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const openPopupEl = document.querySelector('.side-popup[aria-hidden="false"]');
    if (openPopupEl) {
      closePopup(openPopupEl);
    }
  });
};

export { initSidePopup };
